"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _AuthCode = _interopRequireDefault(require("@/components/AuthCode/"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'loginPw',
  components: {
    AuthCode: _AuthCode.default
  },
  data: function data() {
    return {
      loginForm: {}
    };
  },
  computed: {
    agentInfo: function agentInfo() {
      return this.$store.getters.agentInfo;
    }
  },
  mounted: function mounted() {},
  methods: {
    /**
     * 获取验证码
     */
    getAuthCode: function getAuthCode() {
      this.$refs.authCode.getAuthCode({
        phone_num: this.agentInfo.phone,
        type: 7
      });
    },
    /**
     * 修改密码
     */
    postEdit: function postEdit(type) {
      var _this = this;
      var url = 'agentapi/edit_password_save',
        params = this.loginForm;
      if (this.checkRoles(['terminal'])) params.type = 0;
      this.$post(url, params).then(function (res) {
        _this.$message({
          message: '修改成功',
          type: 'success'
        });
      });
    }
  }
};